import { render, staticRenderFns } from "./InHospitalDetail.vue?vue&type=template&id=e0d1a410&scoped=true"
import script from "./InHospitalDetail.vue?vue&type=script&lang=js"
export * from "./InHospitalDetail.vue?vue&type=script&lang=js"
import style0 from "./InHospitalDetail.vue?vue&type=style&index=0&id=e0d1a410&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d1a410",
  null
  
)

export default component.exports